import { CommonResponseModel, PlantIdReq, VehicleTypeReq} from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";
import { UploadResponse } from "packages/libs/shared-models/src/common/vms/masters/vehicles/uploadfile-response";

export class VehicleService extends CommonAxiosService {
    private VehicleController = "/vehicle";

    async createVehicle(payload: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/createVehicle", payload)
    }

    async getAllVehicle(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/getAllVehicle")
    }

    async getActiveAllVehicle(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/getActiveAllVehicle")
    }
    async updateVehicle(dto: any): Promise<CommonResponseModel> {
        return await this.axiosPostCall(this.VehicleController + '/updateVehicle', dto)
    }

    async activateOrDeactivateVehicle(payload: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/activateOrDeactivateVehicle", payload)
    }
    async getAllVehicleDashboard(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/getVehicleDashBoard")
    }

    async getVehicleServiceDashBoard(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/getVehicleServiceDashBoard")
    }
    async getVehicleReminder(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/getVehicleReminder")
    }

    async getAvailableVehiclesList(req:VehicleTypeReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/getAvailableVehiclesList",req)
    }

    async fileUpload(file: any): Promise<UploadResponse>{
        // console.log(file,"file<=====================");
        return await this.axiosPostCall(this.VehicleController + '/fileUpload', file);
    }

    async getVehiclesByType(req: VehicleTypeReq): Promise<UploadResponse>{
        // console.log(req);
        return await this.axiosPostCall(this.VehicleController + '/getVehiclesByType', req);
    }
    async getVehicle(): Promise<UploadResponse>{
        return await this.axiosPostCall(this.VehicleController + '/getVehicle');
    }

    async getVehicleByPlant(req:PlantIdReq): Promise<UploadResponse>{
        return await this.axiosPostCall(this.VehicleController + '/getVehicleByPlant',req);
    }
}
    